export default __webpack_public_path__ + "static/media/stake-more-mlt.102be91e.svg";